module.exports = __webpack_public_path__ + "static/media/HEADING.fe6c1768.png";